/** The canopy height under the cursor, as read from the CHM tile colour (chmSampler.ts). Sits above the attribution control. */
import { Card, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useFormat } from '@/components/useFormat';

export interface ChmReading {
  value: number;
  /** The reading sits at the top of the colour stretch: the height is at least this. */
  saturated: boolean;
}

export function ChmReadout({ reading }: { reading: ChmReading }) {
  const { t } = useTranslation('viewer');
  const { number } = useFormat();
  return (
    <Card padding="xs" radius="lg" shadow="md" data-testid="chm-readout" pos="absolute" bottom={56} right={12} style={{ zIndex: 2, pointerEvents: 'none' }}>
      <Text fz={12} fw={600}>
        {t(reading.saturated ? 'readout.chmSaturated' : 'readout.chm', { value: number(reading.value, 1) })}
      </Text>
    </Card>
  );
}
